import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export default function SectionHeading({ eyebrow, title, accent, sub, align = "left", dark = false }) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} gap-4`}>
      {eyebrow && (
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, ease }}
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-[#B59328]"
        >
          <span className="h-px w-8 bg-[#D4AF37]" />
          {eyebrow}
          {align === "center" && <span className="h-px w-8 bg-[#D4AF37]" />}
        </motion.span>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay: 0.08, ease }}
        className={`max-w-3xl text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-white" : "text-[#0D4B56]"
        }`}
      >
        {title}{" "}
        {accent && <span className="font-script text-[#D4AF37]">{accent}</span>}
      </motion.h2>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.16, ease }}
          className={`max-w-2xl text-base leading-relaxed sm:text-lg ${
            dark ? "text-white/70" : "text-[#475569]"
          }`}
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
}
